import component from "./StyledLink";
export default component;
